import { render, staticRenderFns } from "./BoxEmptyWeight.vue?vue&type=template&id=e00a1120&"
import script from "./BoxEmptyWeight.vue?vue&type=script&lang=ts&"
export * from "./BoxEmptyWeight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports